/**
 * Route tree owned by the connectivity module. The app router composes this
 * tree alongside other modules' trees in `app/router/routes.ts` — it never
 * defines connectivity's child routes itself.
 */
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../app/router/rootRoute';

const ConnectivityDashboard = lazy(() =>
  import('./pages/ConnectivityStatusPage').then((module) => ({
    default: module.ConnectivityDashboard,
  })),
);

const connectivityIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'connectivity/dashboard',
  component: ConnectivityDashboard,
});

export const connectivityRouteTree = connectivityIndexRoute;
